import React from 'react';
import {
  
  InputControl,
  
} from "formik-chakra-ui";

function InputText(props) {
	const {name,title} = props
	const [value, setValue] = React.useState('')
	const handleChange = (event) => setValue(event.target.value)
	return(
		<>
			<div className="field_section">
				
				 <InputControl name={name}  label={title} />
				
			</div>
			
		</>
	);
}

export default InputText;